import React from 'react';
import Button from './Button';

interface ErrorStateProps {
  message?: string;
  onRetry?: () => void;
}

export const ErrorState: React.FC<ErrorStateProps> = ({
  message = 'Something went wrong while loading this section.',
  onRetry,
}) => (
  <div className="flex flex-col items-center justify-center py-8 text-center text-md text-[var(--color-error)]">
    <p className="font-medium mb-2">{message}</p>
    {onRetry && (
      <Button variant="secondary" size="sm" onClick={onRetry}>
        Retry
      </Button>
    )}
  </div>
);

export default ErrorState;

